import * as Blockly from 'blockly/core';
import { create } from 'zustand';
import { FieldFunction } from '@/(routers)/boards/editor/block/definitions/fields/fieldFunction';

interface BlockModalFunctionState {
    workspace: Blockly.WorkspaceSvg | null;
    fieldRef: FieldFunction | null;
    setWorkspace: (ws: Blockly.WorkspaceSvg) => void;
    setFieldRef: (field: FieldFunction) => void;
}

export const useBlockModalFunctionStore = create<BlockModalFunctionState>((set) => ({
    workspace: null,
    fieldRef: null,
    setWorkspace: (ws) => set({ workspace: ws }),
    setFieldRef: (field) => set({ fieldRef: field }),
}));
